import React from 'react';
import {useDispatch, useSelector} from "react-redux";

function DescriptionFormatter({cell}) {

  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();


  return (
    <><input
      type={"text"}



    /></>
  );
}

export default DescriptionFormatter;







